/// <reference path="../typings/externals.d.ts" />
var _mock = require('./lib/Mock');
exports.chai = require('chai');
exports.sinon = require("sinon");
exports.sinonChai = require('sinon-chai');
exports.mocha = require('mocha');
exports.RCSDK = require('../lib/RCSDK');
exports.rcsdk = new exports.RCSDK({
    server: 'http://whatever',
    appKey: 'whatever',
    appSecret: 'whatever'
});
exports.mock = new _mock.Mock(exports.rcsdk);
exports.chai.use(exports.sinonChai);



/*****************
 ** WEBPACK FOOTER
 ** ./src/test/mocha.ts
 ** module id = 58
 ** module chunks = 2
 **/